import { FieldInputProps, useField } from 'formik';
import { DetailedHTMLProps, useState } from 'react';

import { Wrap } from './styled';

type TTextInput<T> = {
  label: string;
} & FieldInputProps<T> &
  DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >;

function TextArea<T = any>({ label, ...props }: TTextInput<T>): JSX.Element {
  const [field, { value }] = useField(props);

  const [isFocus, setIsFocus] = useState(false);

  const handleSetFocusTrue = () => setIsFocus(true);
  const handleSetFocusFalse = () => setIsFocus(false);

  return (
    <Wrap
      className={`${
        isFocus ? 'input-focused input-textarea' : 'input-textarea'
      } ${value ? 'input-has-value' : ''}`}
    >
      <label htmlFor={props.id}>
        {label} {props.required ? <span className="text-yellow">*</span> : ''}
      </label>
      <textarea
        {...props}
        {...field}
        onFocus={handleSetFocusTrue}
        onBlur={handleSetFocusFalse}
      />
    </Wrap>
  );
}

export default TextArea;
